import { useEffect, useRef, useState } from 'react';
import { useApp } from '../store';
import Logo from './Logo';
import { SENDER } from '../mail';

export default function VerifyEmail() {
  const user = useApp((s) => s.user);
  const resendVerification = useApp((s) => s.resendVerification);
  const refreshVerification = useApp((s) => s.refreshVerification);
  const signOutUser = useApp((s) => s.signOutUser);

  const [status, setStatus] = useState('');
  const [busy, setBusy] = useState(false);
  const sentOnce = useRef(false);

  // Accounts created before confirmation was required never received a link — send one on arrival.
  useEffect(() => {
    if (sentOnce.current) return;
    sentOnce.current = true;
    resendVerification().catch(() => {
      setStatus('Could not send automatically — press “Send it again”.');
    });
  }, [resendVerification]);

  const resend = async () => {
    setBusy(true);
    setStatus('');
    try {
      await resendVerification();
      setStatus('Sent. Check your inbox (and your spam folder).');
    } catch {
      setStatus('Could not send just now — wait a minute and try again.');
    } finally {
      setBusy(false);
    }
  };

  const check = async () => {
    setBusy(true);
    setStatus('');
    const ok = await refreshVerification();
    if (!ok) setStatus('Not verified yet. Open the link in the email first, then press this again.');
    setBusy(false);
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="brand login-brand">
          <Logo tile={34} mark={21} />
        </div>
        <h2 className="verify-title">Confirm your email</h2>
        <p className="hint">
          We sent a confirmation link to <strong>{user?.email}</strong>. Open it, then come back here
          and press “I’ve confirmed it”. This is what stops anyone else claiming your email address.
        </p>
        <p className="hint">The email comes from {SENDER} — check spam if you don’t see it.</p>
        {status && <div className="verify-status">{status}</div>}
        <div className="btn-row">
          <button className="btn btn-primary" disabled={busy} onClick={check}>
            I’ve confirmed it
          </button>
          <button className="btn" disabled={busy} onClick={resend}>
            Send it again
          </button>
        </div>
        <button className="link" onClick={signOutUser}>
          Sign out
        </button>
      </div>
    </div>
  );
}
